<div class="modal-header">
  <h5 class="modal-title">
    <ng-container *ngIf="!isEditing" i18n>Set Cost Formula </ng-container>
    <ng-container *ngIf="isEditing" i18n>Edit Cost Formula </ng-container>
    <small
      ><i
        matTooltip="Set an adjustment to the inquiry’s imported booking charges."
        matTooltipPosition="above"
        i18n-matTooltip
        class="fal info fa-question-circle"
      ></i
    ></small>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <span class="far fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <div class="box box-mt-has-pd clearfix">
    <form [formGroup]="form" class="row">
      <div class="col-12">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="base" placeholder="Start the adjustment formula with" i18n-placeholder>
            <mat-option value="total" i18n>Booking Total</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-12 mb-3">
        <mat-button-toggle-group
          formControlName="cumulativeSubtraction"
          tooltip="This allows you to switch the behavior between cumulative subtraction and aggregate subtraction."
          i18n-tooltip
          container="body"
        >
          <mat-button-toggle [value]="false" class="text-sm" i18n> Aggregate </mat-button-toggle>
          <mat-button-toggle [value]="true" class="text-sm" i18n> Cumulative </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div
        formArrayName="formulas"
        *ngFor="let item of formulas.controls; let i = index; let last = last"
        class="col-12"
      >
        <div [formGroupName]="i" class="d-flex gap-3">
          <mat-form-field2 class="mat-block">
            <mat-label i18n> Name: </mat-label>
            <input type="text" formControlName="name" matInput />
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="operation" placeholder="Operation" i18n-placeholder>
              <mat-option value="add" i18n>Add (+)</mat-option>
              <mat-option value="subtract" i18n>Subtract (-)</mat-option>
            </mat-select>
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <mat-label> <ng-container i18n>Amount</ng-container> ({{ operator(i) }}): </mat-label>
            <input type="text" formControlName="amount" matInput />
            <mat-error i18n *ngIf="item.get('amount').hasError('min')"> Minimum value is 0. </mat-error>
            <mat-error i18n *ngIf="item.get('amount').hasError('max')"> Maximum value is 100. </mat-error>
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="type" placeholder="Type" i18n-placeholder>
              <mat-option value="percent" i18n>Percent</mat-option>
              <mat-option value="flat" i18n>Flat</mat-option>
            </mat-select>
          </mat-form-field2>
          <div class="align-input-row-end">
            <button *ngIf="!last" (click)="removeFormula(i)" type="button" class="btn btn-light-danger">
              <i class="fas fa-minus"></i>
            </button>
            <button *ngIf="last" (click)="addFormula()" type="button" class="btn btn-light-info">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" [ngClass]="config.cancelBtnClass">
    <i class="far fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button (click)="onClear()" type="button" [ngClass]="config.clearBtnClass">
    <i class="fal fa-sync"></i> <ng-container i18n>Reset</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" [ngClass]="config.doneBtnClass">
    <i [ngClass]="config.doneBtnIconClass"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
